/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Support_Submitticket_Error_Description1Inputs */

const en_support_submitticket_error_description1 = /** @type {(inputs: Support_Submitticket_Error_Description1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`An error occurred while submitting your ticket. Please try again.`)
};

/**
* | output |
* | --- |
* | "An error occurred while submitting your ticket. Please try again." |
*
* @param {Support_Submitticket_Error_Description1Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const support_submitticket_error_description1 = /** @type {((inputs?: Support_Submitticket_Error_Description1Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Support_Submitticket_Error_Description1Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_support_submitticket_error_description1(inputs)
});
export { support_submitticket_error_description1 as "support_submitTicket_error_description" }